<div class="container mt-5">
  @if (hasApiError) {
    <div class="alert alert-danger" role="alert">
      {{apiError}}
    </div>
  }
  <table mat-table [dataSource]="organisations">

    <!--- Note that these columns can be defined in any order.
    The actual rendered columns are set as a property on the row definition" -->


    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Name </th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <ng-container matColumnDef="cpu_seconds_remaining">
      <th mat-header-cell *matHeaderCellDef> CPU Credit (s) </th>
      <td mat-cell *matCellDef="let element"> {{element.cpu_seconds_remaining}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element"><a (click)="selectOrg(element)" href="javascript:void(0)">Masquerade</a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>